import { Link } from 'react-router-dom';
import { getConfig } from '../../../utils/config';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const Footer1 = () => {
    const config = getConfig();
    const c = config?.footer;
    const history = useHistory();
    const navigateTnC = () => {
        history.push('/terms-and-conditions');
    };

    return (
        <div
            className={`bg-primary xl:px-16 px-8 py-5 text-gray-100 border-t-4 border-secondary`}
        >
            <div className=" w-full mt-2 flex flex-col lg:flex-row justify-end ">
                <div>
                    <h2
                        className={
                            c?.footerHeadingClassName
                                ? c?.footerHeadingClassName
                                : 'text-3xl uppercase'
                        }
                    >
                        {c?.footerHeading || 'CORPORATE OFFICE'}
                    </h2>
                    <p
                        className={
                            c?.clientAddressClassName
                                ? c?.clientAddressClassName
                                : 'pt-3 font-brandFont'
                        }
                    >
                        {c?.clientAddress}
                    </p>{' '}
                </div>{' '}
                <div className="w-full  flex lg:justify-end mt-5 lg:mt-0">
                    <div className="text-left">
                        <Link
                            to={c?.contactUsPath || '/contact-us'}
                            className={
                                c?.contactUsClassName
                                    ? c?.contactUsClassName
                                    : ' text-left pt-4 font-brandFont'
                            }
                        >
                            Contact Us
                        </Link>
                    </div>
                    <span className="px-2">|</span>
                    <div className="text-right">
                        <Link
                            onClick={navigateTnC}
                            className={
                                c?.termsAndConditionsClassName
                                    ? c?.termsAndConditionsClassName
                                    : 'pt-4 font-brandFont'
                            }
                        >
                            Terms and Conditions
                        </Link>
                    </div>
                </div>
            </div>

            <hr className="w-full bg-gray-100 mt-4 lg:mt-10 mb-4  border-none h-[1px]"></hr>
            <details>
                <summary className="font-Helvetica_Light cursor-pointer">
                    {' '}
                    Disclaimer
                </summary>{' '}
                <div className="w-full  text-justify">
                    <p
                        className={
                            c?.footerContent1ClassName
                                ? c?.footerContent1ClassName
                                : ' font-brandFont text-accent-content'
                        }
                    >
                        {c?.footerContent1}
                    </p>
                    <p
                        className={
                            c?.footerContent2ClassName
                                ? c?.footerContent2ClassName
                                : 'pt-4 font-brandFont text-accent-content'
                        }
                    >
                        {c?.footerContent2}
                    </p>
                </div>
                <div className="w-full md:flex">
                    <div className="w-[90%] md:w-[20%]  lg:w-[20%] xl:w-[15%] text-left align-middle m-auto ">
                        <img
                            src={
                                c?.logo || 'https://cdn.loyalie.in/53565661.png'
                            }
                            alt="RELOY"
                        />
                    </div>
                    <div className="xl:w-[85%] lg:w-[80%] md:w-[80%] text-justify xl:text-sm lg:pl-4  py-4">
                        <p
                            className={` ${config?.blogs?.fontBody} ${
                                c?.contentClassName ||
                                'font-brandFont text-accent-content'
                            }`}
                        >
                            {c?.content}
                        </p>
                    </div>
                </div>
            </details>
        </div>
    );
};

export default Footer1;
